// extracted by mini-css-extract-plugin
module.exports = {"Box":"BoxKeyValue_Box__pAaBj"};